import moment from 'moment';
import SeatNone from '../../../assets/images/seatInfo.svg';
import SeatInfoIcon from '../../../assets/images/seatWithHuman.svg';
export const SeatInfo = ({ data }) => {
  return (
    <div className="flex w-full items-center justify-center gap-4 h-full flex-col p-5">
      <div className="flex flex-row w-full h-full items-center justify-between">
        <div className="flex h-full  items-center flex-row gap-2">
          <div className="size-14 flex items-center justify-center  rounded-full ">
            <img src={data.status === 'none' ? SeatNone : SeatInfoIcon} />
          </div>
          <div className="flex place-items-start  text-sm flex-col">
            <div>Koltuk No: {data.loadCell.seat.seatNo}</div>
            <div className="w-full text-left text-gray-500 italic">
              {data.status === 'none' ? 'Yolcu ayağa kalktı.' : 'Yolcu oturdu.'}
            </div>
          </div>
        </div>
      </div>
      <div className="flex text-left flex-row gap-3 justify-between w-full text-sm">
        <div className="flex flex-col items-center text-left justify-center ">
          <div className="text-xs w-full  text-gray-500">Plaka</div>
          <div className="w-full">
            {data.transportation.transportation.vehicle.id}
          </div>
        </div>
        <div className="flex flex-col items-center text-left justify-center ">
          <div className="text-xs w-full  text-gray-500">Sürücü</div>
          <div className="w-full">
            {data.transportation.transportation.driver.firstname}{' '}
            {data.transportation.transportation.driver.lastname}{' '}
          </div>
        </div>
        <div className="flex flex-col items-center text-left justify-center ">
          <div className="text-xs w-full  text-gray-500">Kordinat</div>
          <div className="w-full">{data.coordinate}</div>
        </div>
        <div className="flex flex-col items-center text-left justify-center ">
          <div className="text-xs w-full  text-gray-500">Tarih ve Saat</div>
          <div className="w-full">
            {moment(data.time).format('DD.MM.YYYY HH:MM')}
          </div>
        </div>
      </div>
    </div>
  );
};
